var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCurrentState || _vm.show)?_c(_vm.rootTag,{tag:"component",staticClass:"state-wrapper"},[_vm._t("default",null,null,_vm.manager.functionality)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }